export default __webpack_public_path__ + "static/pickup-e7de9a3b59ffd75c67ae429134329359.webp";